let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cbgbu")).then(() => parcelRequire('2DJbP'));